import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getPasscodesAdmin, addPasscode, deletePasscode } from '../../services/adminService';

export default function AdminPasscodes() {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ passcode: '', label: '' });
  const [saving, setSaving] = useState(false);

  const load = () => getPasscodesAdmin().then(d => { setCodes(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.passcode.trim()) return;
    setSaving(true);
    await addPasscode({ passcode: form.passcode.trim(), label: form.label.trim(), order: codes.length });
    setForm({ passcode: '', label: '' });
    await load();
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this passcode?')) return;
    await deletePasscode(id);
    setCodes(p => p.filter(c => c.id !== id));
  };

  return (
    <AdminLayout title="Bride Passcodes">
      <div className="admin-section">
        <div className="admin-section-header"><h2>Add New Passcode</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleAdd} style={{ maxWidth: 460 }}>
            <div className="admin-form-row">
              <div><label>Passcode</label><input value={form.passcode} onChange={e => setForm(f => ({ ...f, passcode: e.target.value }))} placeholder="e.g. SHRIJI2024" required /></div>
              <div><label>Label (optional)</label><input value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))} placeholder="e.g. Priya's Wedding" /></div>
            </div>
            <div><button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Add Passcode'}</button></div>
          </form>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header"><h2>Active Passcodes ({codes.length})</h2></div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            codes.length === 0 ? <div className="admin-empty">No passcodes yet</div> : (
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead><tr><th>#</th><th>Passcode</th><th>Label</th><th>Action</th></tr></thead>
                  <tbody>
                    {codes.map((c, i) => (
                      <tr key={c.id}>
                        <td>{i + 1}</td>
                        <td><code style={{ background: '#f5f0eb', padding: '2px 8px', borderRadius: 4 }}>{c.passcode}</code></td>
                        <td>{c.label || <span style={{ color: 'var(--a-text-muted)' }}>—</span>}</td>
                        <td><button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(c.id)}>Delete</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
